import {getMethod} from '~/api'

async function get(request) {
    return await getMethod('/api/activityAdditionalOptions', request)
}

export {get}
